import React from 'react'
import BoxGrid from './boxGrid/boxGrid'

 function BoxGridHolder(props) {
    const {getRiskStatistics} = props;
  return (
    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        {getRiskStatistics.length > 0 ?  <BoxGrid benchmark_data={getRiskStatistics}/> : null}
    </div>
  )
}

export default BoxGridHolder;


// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/statistics/RiskStatistic/section2/boxGridHolder.jsx